import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Cross: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M18 19a1 1 0 0 1-.71-.29L12 13.41l-5.29 5.3a1 1 0 0 1-1.42-1.42l5.3-5.29-5.3-5.29a1 1 0 0 1 1.42-1.42l5.29 5.3 5.29-5.3a1 1 0 1 1 1.42 1.42L13.41 12l5.3 5.29a1 1 0 0 1 0 1.42A1 1 0 0 1 18 19Z" />
  </Icon>
);

export default Cross;
